import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";
import ProviderItemBasisV2 from "./ProviderItemBasisV2";
import AddressSearchCatalogContainer from "Containers/AddressSearchCatalogContainer";
import TariffTableContainerInCatalog from "Containers/TariffTableContainerInCatalog";
import RecentlyConnectedTariffConnectHOC from "HOC/RecentlyConnectedTariffConnectHOC";

const styles = (theme) => {
	return {
		lowHeight: {
			height: "265px !important",
			[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
				height: "265px !important",
			},
			[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
				height: "auto",
			},
			[`@media (max-width: ${theme.media.sm})`]: {
				height: "auto !important",
			},
		},
		root: {
			width: "280px",
			borderRadius: "10px",
			backgroundColor: theme.palette.colors.white,
			border: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
			marginRight: "10px",
			marginLeft: "10px",
			marginBottom: "20px",
			position: "relative",
			padding: "30px 30px 25px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
		wrapper: {
			width: "100%",
			height: "100%",
			minHeight: "100px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			justifyContent: "space-between",
			marginBottom: "10px",
			marginTop: "20px",
		},
		counter: {
			position: "absolute",
			top: "14px",
			right: "14px",
			fontFamily: theme.fonts.medium,
			fontSize: "16px",
			lineHeight: 1.25,
			letterSpacing: "1.6",
			color: theme.palette.colors.oneMoreGrey,
		},
		logoWrapper: {
			width: "100%",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			marginBottom: "20px",
			height: "60px",
		},
		logo: {
			display: "flex",
			justifyContent: "center",
			maxWidth: "100%",
			maxHeight: "60px",
			objectFit: "scale-down",
		},
		infoWrapper: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			marginBottom: "20px",
		},
		infoNameWrapper: {},
		subtext: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			letterSpacing: "2px",
			color: theme.palette.colors.oneMoreGrey,
		},
		nameWrapper: {
			minHeight: "40px",
			width: "100%",
			textAlign: "center",
		},
		name: {
			fontFamily: theme.fonts.medium,
			fontSize: "16px",
			lineHeight: 1.25,
			color: theme.palette.colors.darkSlateBlue,
			textAlign: "center",
		},
		searchWrapper: {
			marginBottom: "28px",
		},
		priceWrapper: {
			textAlign: "center",
			marginBottom: "20px",
		},
		speedWrapper: {
			textAlign: "center",
		},
		mainText: {
			fontFamily: theme.fonts.bold,
			fontSize: "24px",
			lineHeight: "0.83",
			letterSpacing: "-.5px",
			color: theme.palette.colors.darkSlateBlue2,
			marginBottom: "12px",
		},
		buttons: {
			marginTop: "auto",
			width: "100%",
		},
		buttonsItem: {
			height: "40px",
			borderRadius: "10px",
			border: `solid 1px ${theme.palette.colors.purplishBlue}`,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			width: "100%",
			textTransform: "uppercase",
			cursor: "pointer",
			userSelect: "none",
		},
		buttonsItemText: {
			fontFamily: theme.fonts.bold,
			fontSize: "14px",
			lineHeight: 1.29,
			letterSpacing: "1.6px",
			color: theme.palette.colors.purplishBlue,
		},
		isElite: {
			border: `1px solid ${theme.palette.colors.purplishBlue}`,
		},
		absorbWrapper: {},
		absorbItem: {},
		absorbItemSecond: {},
		absorbArrow: {},
		absorbArrowText: {},
		absorbArrowWrapper: {
			textAlign: "center",
		},
		isAbsorb: {
			"& $absorbWrapper": {
				width: "100%",
				height: "100%",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
			},
			"& $absorbItem": {
				width: "100%",
				display: "flex",
				justifyContent: "center",
				flexWrap: "wrap",
			},
			"& $absorbItemSecond": {
				width: "100%",
				"& $logoWrapper": {
					marginBottom: "10px",
				},
			},
			"& $nameWrapper": {
				minHeight: 0,
				marginBottom: 0,
			},
			"& $absorbArrowWrapper": {
				margin: "20px 0",
			},
			"& $absorbArrow": {
				color: theme.palette.colors.disabled,
				fontSize: "24px",
			},
			"& $absorbArrowText": {
				color: theme.palette.colors.disabled,
				fontFamily: theme.fonts.medium,
				fontSize: "12px",
				letterSpacing: "2px",
				textTransform: "uppercase",
				marginBottom: "5px",
			},
		},
		isFlat: {
			width: "100%",
			margin: 0,
			padding: "0 30px",
			border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
			borderRadius: "10px",
			marginBottom: "40px",
			"&:first-child": {
				borderTopLeftRadius: "10px",
				borderTopRightRadius: "10px",
				borderTop: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
			},
			"&:last-child": {
				borderBottomLeftRadius: "10px",
				borderBottomRightRadius: "10px",
			},
			"& $wrapper": {
				flexDirection: "row",
			},
			"& $counter": {
				display: "none",
			},
			"& $infoWrapper": {
				marginBottom: 0,
			},
			"& $searchWrapper": {
				display: "flex",
				flexDirection: "row",
				marginBottom: 0,
			},
			"& $priceWrapper": {
				marginBottom: 0,
				marginRight: "40px",
			},
			"& $logoWrapper": {
				marginBottom: 0,
				width: "130px",
				height: "auto",
				flexShrink: 0,
			},
			"& $logo": {
				height: "auto",
			},
			"& $nameWrapper": {
				minHeight: 0,
				textAlign: "center",
				textOverflow: "ellipsis",
				width: "160px",
			},
			"& $name": {
				textAlign: "left",
				textOverflow: "ellipsis",
				overflow: "hidden",
				whiteSpace: "nowrap",
			},
			"& $buttons": {
				marginTop: 0,
				width: "270px",
				display: "flex",
			},
			"& $buttonsItem": {
				width: "100%",
				borderRadius: "10px",
			},
			"&$isElite": {
				border: `solid 1px ${theme.palette.colors.purplishBlue}`,
				"&:first-child": {
					borderTop: `solid 1px ${theme.palette.colors.purplishBlue}`,
				},
			},
			"&$isAbsorb": {
				"& $absorbWrapper": {
					flexDirection: "row",
					alignItems: "center",
				},
				"& $absorbItem": {
					width: "350px",
					justifyContent: "flex-start",
					alignItems: "center",
				},
				"& $absorbItemSecond": {
					width: "350px",
					"& $logoWrapper": {
						marginBottom: 0,
					},
				},
				"& $absorbArrowWrapper": {
					margin: "0 16px",
					flexShrink: 0,
				},
				"& $logoWrapper": {
					width: "130px",
					marginBottom: 0,
					marginRight: "24px",
				},
				"& $logo": {
					height: "auto",
					maxHeight: "60px",
				},
				"& $nameWrapper": {
					width: "auto",
				},
				"& $absorbArrowText": {
					marginBottom: 0,
				},
				"& $absorbArrow": {
					transform: "rotate(-90deg)",
					display: "block",
				},
			},
			dropdownButton: {},
			mobileWrapper: {},
		},
		dropdownButton: {},
		mobileWrapper: {},
		allTariffsBtn: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			letterSpacing: "2px",
			color: theme.palette.colors.oneMoreGrey,
			display: "flex",
			width: "100%",
			height: "70px",
			textTransform: "uppercase",
			textAlign: "center",
			justifyContent: "center",
			alignItems: "center",
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			root: {
				width: "220px",
				padding: "0px 20px 0px",
			},
			listIsCount2: {},
			listIsHideDescription: {
				"&$listIsCount2": {
					width: "55%",
				},
			},
			logoWrapper: {},
			logo: {},
			nameWrapper: {},
			name: {},
			isAbsorb: {},
			absorbWrapper: {},
			absorbItem: {},
			absorbItemSecond: {},
			buttonsItemText: {
				fontSize: "12px",
				letterSpacing: "1.5",
			},
			buttons: {
				width: "calc(100% + 20px)",
			},
			isFlat: {
				width: "100%",
				padding: "30 20px",
				"& $logoWrapper": {
					marginBottom: 0,
					width: "110px",
					// marginRight: "20px",
				},
				"& $logo": {
					height: "auto",
				},
				"& $nameWrapper": {
					minHeight: 0,
					textAlign: "center",
					marginBottom: 0,
					width: "160px",
					paddingRight: 0,
				},
				"&$isAbsorb": {
					"& $absorbWrapper": {
						flexDirection: "row",
						alignItems: "center",
					},
					"& $absorbItem": {
						width: "350px",
						display: "flex",
						justifyContent: "flex-start",
						flexWrap: "nowrap",
						alignItems: "center",
					},
					"& $absorbItemSecond": {
						width: "350px",
						"& $logoWrapper": {
							marginBottom: 0,
						},
					},
					"& $logoWrapper": {
						marginBottom: 0,
						width: "110px",
					},
					"& $logo": {
						height: "auto",
					},
					"& $nameWrapper": {
						minHeight: 0,
						marginBottom: 0,
						maxWidth: "100px",
					},
					"& $name": {
						textAlign: "center",
					},
					"& $buttons": {
						minWidth: "200px",
					},
				},
			},
			allTariffsBtn: {
				marginBottom: "0px",
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				width: "170px",
				marginRight: "5px",
				marginLeft: "5px",
				marginBottom: "10px",
				padding: "30px 0 0",
			},
			counter: {
				fontSize: "14px",
			},
			logoWrapper: {
				width: "80%",
			},
			logo: {},
			nameWrapper: {},
			name: {},
			subtext: {
				fontSize: "12px",
			},
			mainText: {
				marginBottom: "5px",
				fontSize: "18px",
			},
			priceWrapper: {
				marginBottom: "24px",
			},
			buttons: {},
			buttonsItem: {
				height: "50px",
				borderRadius: 0,
				border: "none",
				borderTop: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
			},
			buttonsItemText: {
				fontSize: "10px",
				letterSpacing: "1.33",
			},
			isAbsorb: {},
			absorbWrapper: {},
			absorbItem: {},
			absorbItemSecond: {},
			isFlat: {
				width: "100%",
				padding: "0px 20px",
				margin: 0,
				marginBottom: "40px",
				"& $logoWrapper": {
					marginBottom: 0,
					width: "110px",
					// marginRight: "20px",
				},
				"& $logo": {
					height: "auto",
				},
				"& $subtext": {
					fontSize: "14px",
				},
				"& $mainText": {
					fontSize: "24px",
				},
				"& $infoWrapper": {
					flexDirection: "column",
					marginRight: "40px",
				},
				"& $buttons": {
					marginTop: 0,
					width: "210px",
					display: "flex",
					marginLeft: "auto",
				},
				"& $buttonsItem": {
					height: "40px",
					borderRadius: "10px",
					width: "100%",
					fontSize: "12px",
					border: `1px solid ${theme.palette.colors.purplishBlue}`,
				},
				"&$isAbsorb": {
					height: "auto",
					padding: "10px 20px",
					"& $absorbWrapper": {
						flexDirection: "row",
						alignItems: "center",
					},
					"& $absorbItem": {
						width: "150px",
						display: "flex",
						justifyContent: "flex-start",
						flexWrap: "nowrap",
						alignItems: "center",
						flexDirection: "column",
					},
					"& $absorbItemSecond": {
						width: "150px",
						"& $logoWrapper": {
							marginBottom: "0",
						},
					},
					"& $logoWrapper": {
						marginBottom: "0",
						width: "110px",
						marginRight: 0,
					},
					"& $logo": {
						height: "auto",
						maxHeight: "40px",
					},
					"& $nameWrapper": {
						minHeight: 0,
						marginBottom: 0,
						maxWidth: "100px",
						display: "block",
						paddingRight: "0",
					},
					"& $name": {
						textAlign: "center",
					},
				},
			},
			allTariffsBtn: {
				marginBottom: "0px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				width: "100%",
				height: "auto",
				minHeight: "100px",
				backgroundColor: theme.palette.colors.white,
				marginRight: 0,
				marginLeft: 0,
				padding: "15px",
				alignItems: "center",
				border: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
				borderTop: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
				borderRadius: "10px",
				marginBottom: "16px",
			},
			wrapper: {
				height: "auto",
				justifyContent: "space-between",
			},
			infoWrapper: {
				marginBottom: 0,
			},
			searchWrapper: {
				display: "flex",
				marginBottom: 0,
			},
			priceWrapper: {
				marginRight: "24px",
				marginBottom: 0,
			},
			subtext: {
				fontSize: "12px",
			},
			mainText: {
				fontSize: "18px",
				marginBottom: "8px",
			},
			counter: {
				display: "none",
			},
			logoWrapper: {
				display: "flex",
				justifyContent: "center",
				marginBottom: 0,
				width: "120px",
				flexShrink: 0,
				height: "auto",
				// marginRight: "24px",
			},
			nameWrapper: {
				minHeight: 0,
				textAlign: "center",
				marginBottom: "0",
			},
			name: {
				textAlign: "left",
			},
			buttons: {
				position: "absolute",
				right: 0,
				left: 0,
				bottom: 0,
				height: "50px",
			},
			buttonsItem: {
				border: "none",
				borderRadius: "0",
				height: "100%",
				borderTop: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
			},
			buttonsItemText: {
				fontSize: "12px",
			},
			isElite: {
				border: `solid 1px ${theme.palette.colors.purplishBlue}`,
				borderTop: `solid 1px ${theme.palette.colors.purplishBlue}`,
			},
			absorbWrapper: {},
			absorbArrow: {},
			absorbItem: {},
			absorbItemSecond: {},
			absorbArrowWrapper: {},
			isAbsorb: {
				"& $absorbWrapper": {
					height: "auto",
					flexDirection: "row",
					alignItems: "center",
				},
				"& $absorbItem": {
					width: "40%",
					display: "flex",
					justifyContent: "center",
					flexWrap: "wrap",
					marginRight: "auto",
				},
				"& $absorbItemSecond": {
					width: "40%",
					marginLeft: "auto",
					marginRight: 0,
					"& $logoWrapper": {
						marginBottom: 0,
					},
				},
				"& $absorbArrowWrapper": {
					flexShrink: 0,
				},
				"& $absorbArrow": {
					color: theme.palette.colors.lightGrayishViolet,
					margin: "0 0 0 -12px",
					fontSize: "24px",
					position: "absolute",
					transform: "rotate(-90deg) translateX(50%)",
					left: "50%",
					top: "50%",
				},
				"& $nameWrapper": {
					minHeight: 0,
					marginBottom: 0,
					textAlign: "center",
				},
				"& $name": {
					textAlign: "center",
				},
				"& $logoWrapper": {
					marginBottom: 0,
					width: "100%",
					marginRight: 0,
				},
			},
			isFlat: {
				borderRadius: "10px",
				marginBottom: "16px",
				"& $wrapper": {
					height: "auto",
					flexDirection: "row",
					justifyContent: "space-between",
				},
				"& $infoWrapper": {
					marginBottom: 0,
				},
				"& $searchWrapper": {
					display: "flex",
					marginBottom: 0,
				},
				"& $priceWrapper": {
					marginRight: "24px",
					marginBottom: 0,
				},
				"& $logoWrapper": {
					display: "flex",
					justifyContent: "center",
					marginBottom: 0,
					width: "120px",
					flexShrink: 0,
					height: "auto",
					// marginRight: "24px",
				},
				"& $nameWrapper": {
					minHeight: 0,
					width: "auto",
					textAlign: "center",
					marginBottom: "0",
				},
				"& $buttons": {
					position: "absolute",
					right: 0,
					left: 0,
					bottom: 0,
					height: "50px",
					width: "100%",
				},
				"& $buttonsItem": {
					border: "none",
					borderRadius: "0",
					height: "100%",
					borderTop: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
				},
				"&$isAbsorb": {
					"& $absorbWrapper": {
						height: "auto",
						flexDirection: "row",
						alignItems: "center",
					},
					"& $absorbItem": {
						width: "40%",
						display: "flex",
						justifyContent: "center",
						flexWrap: "wrap",
						marginRight: "auto",
					},
					"& $absorbItemSecond": {
						width: "40%",
						marginLeft: "auto",
						marginRight: 0,
						"& $logoWrapper": {
							marginBottom: 0,
						},
					},
					"& $absorbArrowWrapper": {
						flexShrink: 0,
						margin: "20px 0",
					},
					"& $absorbArrow": {
						color: theme.palette.colors.lightGrayishViolet,
						margin: "0 0 0 -12px",
						fontSize: "24px",
						position: "absolute",
						transform: "rotate(-90deg) translateX(50%)",
						left: "50%",
						top: "50%",
						marginBottom: 0,
					},
					"& $nameWrapper": {
						minHeight: 0,
						marginBottom: 0,
						textAlign: "center",
						paddingRight: 0,
					},
					"& $name": {
						textAlign: "center",
					},
					"& $logoWrapper": {
						marginBottom: 0,
						width: "100%",
						marginRight: 0,
					},
				},
			},
			allTariffsBtn: {
				height: "40px",
				marginBottom: "-15px",
			},
		},
		[`@media (max-width: 500px)`]: {
			infoWrapper: {
				flexDirection: "column",
			},
			logoWrapper: {
				marginRight: 0,
				width: "100px",
			},
			searchWrapper: {
				display: "block",
			},
			priceWrapper: {
				display: "flex",
				alignItems: "center",
				marginBottom: "5px",
				"& $subtext": {
					marginTop: "-5px",
					marginLeft: "4px",
				},
			},
			speedWrapper: {
				display: "flex",
				alignItems: "center",
				"& $subtext": {
					marginTop: "-5px",
					marginLeft: "4px",
				},
			},
			mobileWrapper: {
				marginLeft: "5%",
			},
			isFlat: {
				"& $infoWrapper": {
					flexDirection: "column",
				},
				"& $logoWrapper": {
					marginRight: 0,
					width: "100px",
				},
				"& $searchWrapper": {
					display: "block",
				},
				"& $priceWrapper": {
					display: "flex",
					alignItems: "center",
					marginBottom: "5px",
					"& $subtext": {
						marginTop: "-5px",
						marginLeft: "4px",
					},
				},
				"& $speedWrapper": {
					display: "flex",
					alignItems: "center",
					"& $subtext": {
						marginTop: "-5px",
						marginLeft: "4px",
					},
				},
			},
		},
	};
};

class ProviderItemV2 extends ProviderItemBasisV2 {
	generateAllTariffButton() {
		let item = this.props.data;
		let classes = this.props.classes;
		let text = this.props.text;
		let data = this.props.data;
		let tariffs = this.props.tariffs;
		let viewCountTariff = this.props.viewCountTariff;
		let countTariff = data?.info?.cnt_tariffs || 0;
		let someTariffs =
			this.props.pageName === "catalog_prov" || this.props.pageName === "district_prov"
				? tariffs.filter((item) => {
						if (item.provider.id === data.id) return true;
					})
				: [];
		let buttonAllTariffs = (
			<p>
				{text.ALL_RATES}
				{viewCountTariff && !!countTariff && " (" + countTariff + ")"}
			</p>
		);
		if (!someTariffs?.length) {
			return null;
		} else {
			return React.cloneElement(this.props.linkComponent, {
				onClick: this.preventPropagation,
				to: this.props.generateProviderRates(item),
				className: classes.allTariffsBtn,
				children: buttonAllTariffs,
			});
		}
	}

	render() {
		let item = this.props.data;
		let classes = this.props.classes;
		let data = this.props.data;
		let tariffs = this.props.tariffs;
		let someTariffs = tariffs.filter((item) => {
			if (item.provider.id === data.id) return true;
		});

		return (
			<div
				className={classNames(classes.root, {
					[classes.isElite]: item.vip_provider == 1,
					[classes.isFlat]: this.props.flat,
					[classes.lowHeight]: Object.keys(item.info).length === 0 && !this.props.flat,
				})}
				datatest="providers_provider_button"
			>
				<div className={classes.wrapper}>
					<div onClick={() => this.props.onProviderSelect()} className={classes.infoWrapper}>
						{this.generateLogo(item)}
						<div className={classes.infoNameWrapper}>
							<div className={classes.nameWrapper}>
								{React.cloneElement(this.props.linkComponent, {
									onClick: this.preventPropagation,
									to: this.props.generateProviderUrl(item),
									className: classes.subtext,
									children: item.name,
								})}
							</div>
						</div>
					</div>
					<RecentlyConnectedTariffConnectHOC>
						<AddressSearchCatalogContainer
							sendGAWhenFulled={true}
							withQuiz={true}
							onProviderConnect={this.props.onProviderConnect}
							data={data}
						/>
					</RecentlyConnectedTariffConnectHOC>
				</div>
				{!!someTariffs.length && (
					<TariffTableContainerInCatalog
						showNames={true}
						providers={[item]}
						tariffs={someTariffs}
						compareIsHide={true}
						isProviderCatalog={this.props.isProviderCatalog}
						hideProviderLogo={this.props.hideProviderLogo}
						isRegionRatesTag={this.props.isRegionRatesTag}
						pageName={this.props.pageName}
					/>
				)}
				{this.generateAllTariffButton()}
				{this.generateCommonPart()}
			</div>
		);
	}
}

export default withStyles(styles)(ProviderItemV2);
